import BusinessVerticalsService from "@/api/services/businessVerticals";
import { toCamelCase } from "@estaly/ui";

const ALL_BUSINESS_VERTICALS_PER_PAGE = 10000;

const initialState = {
  index: [],
};

export default {
  namespaced: true,
  state: initialState,
  mutations: {
    setIndex(state, businessVerticals) {
      state.index = businessVerticals;
    },
  },
  actions: {
    async fetchIndex({ commit }) {
      const response = await BusinessVerticalsService.fetchIndex({
        perPage: ALL_BUSINESS_VERTICALS_PER_PAGE,
        includes: ["store", "store.organization"],
      });
      if (!response?.success) return response;

      const data = toCamelCase(response.data);
      commit("setIndex", data.records);
      return response;
    },

    async fetchStoreVerticals(_, storeId) {
      const response = await BusinessVerticalsService.fetchIndex({
        storeId: [storeId],
        enabled: true,
        perPage: ALL_BUSINESS_VERTICALS_PER_PAGE,
      });
      if (!response?.success) return null;

      return toCamelCase(response.data).records;
    },
  },
};
